import React from 'react'

export default ({ image }) => {
  if (image === undefined) {
    return <React.Fragment />
  }

  return (
    <div className="event-media media-image">
      <img src={image.source_url} alt={image.title} />
    </div>
  )
}
